import React, { Component } from 'react'

import utils from '../utils'
const { FE } = utils

export default class PlayItem extends Component {
  render(){
    let { activity, pvId } = this.props,
    itemUrl = FE.Utils.getHref(`${activity.mUrl}#pvareaid=${pvId}`)

    return(
      <a className='play-item' href={itemUrl}>
        <p>{activity.name}</p>
        <div>
          {
            activity.giftList.map(gift => <div key={Math.random()}>
              <img className='shop-right' src={gift.giftImgUrl} alt=""/>
            </div>)
          }
        </div>
      </a>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/PlayItem.js